/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CustomEliteConfigurationControllerDeleteConfiguration$Params {
  uuid: string;
}

export function customEliteConfigurationControllerDeleteConfiguration(http: HttpClient, rootUrl: string, params: CustomEliteConfigurationControllerDeleteConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, customEliteConfigurationControllerDeleteConfiguration.PATH, 'delete');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

customEliteConfigurationControllerDeleteConfiguration.PATH = '/custom-elite-configuration/{uuid}';
